import React from 'react';
import { CRow, CCol, CSpinner } from '@coreui/react';
import marketArbol from '../../../assets/brand/arbol.png';
import marketAlumbrado from '../../../assets/brand/alumbrado.png';
import marketSemaforo from '../../../assets/brand/semaforo.png';
import marketBasura from '../../../assets/brand/basura.png';
import marketBaches from '../../../assets/brand/baches.png';
import marketRuta from '../../../assets/brand/ruta.png';
import marketMapaSeñal from '../../../assets/brand/mapa-señal.png';
import { StatsSkeleton } from '../SkeletonDetails';

const StatsCards = ({ dataProyecto, mapFilter, handleCardFilter, isLoading, activeSubFilter, handleSubFilterClick }) => {
    const getCount = (idx, key) => dataProyecto?.cantidad_senales?.[idx]?.[key] || 0;

    const countArbol = getCount(1, 'senales_arbol');
    const countAlumbrado = getCount(0, 'senales_alumbrado');
    const countSemaforo = getCount(2, 'senales_semaforo');
    const countBasura = getCount(3, 'senales_basura');
    const countBaches = getCount(4, 'senales_baches');
    const countSenHoriz = 0; // Por ahora 0 hasta que la API lo devuelva
    const totalCount = getCount(5, 'senales_totales');

    const cards = [
        { type: 'all', icon: marketMapaSeñal, label: 'Todos', count: totalCount },
        { type: 'arbol', icon: marketArbol, label: 'Árbol', count: countArbol },
        { type: 'alumbrado', icon: marketAlumbrado, label: 'Alumbrado', count: countAlumbrado },
        { type: 'semaforo', icon: marketSemaforo, label: 'Semáforo', count: countSemaforo },
        { type: 'basura', icon: marketBasura, label: 'Basura', count: countBasura },
        { type: 'bache', icon: marketBaches, label: 'Baches', count: countBaches },
        { type: 'sen_horiz', icon: marketRuta, label: 'Señ Horiz', count: countSenHoriz, comingSoon: true },
    ];

    if (isLoading && !dataProyecto) return <StatsSkeleton />;

    return (
        <div className="stats-cards-container mt-4">
            <div className="d-flex flex-wrap justify-content-center gap-2">
                {cards.map((card, idx) => {
                    const isActive = mapFilter === card.type;
                    return (
                        <div
                            key={idx}
                            className={`stats-card-premium ${isActive ? 'active' : ''} ${card.comingSoon ? 'disabled' : ''}`}
                            onClick={() => !card.comingSoon && handleCardFilter(card.type, card.type)}
                        >
                            <div className="stats-card-content">
                                <div className="stats-card-icon-wrapper">
                                    <img src={card.icon} alt={card.label} className="stats-card-icon" />
                                </div>
                                <div className="stats-card-info">
                                    <div className="stats-card-label">
                                        {card.label}
                                        {card.comingSoon && (
                                            <span className="coming-soon-badge-premium ml-2">PROX</span>
                                        )}
                                    </div>
                                    <div className="stats-card-value">
                                        <span className="current-value">{card.count}</span>
                                        <span className="total-label"> Total</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default React.memo(StatsCards);
